export default {"src":"/_next/static/media/bg.ed98671f.svg","height":212,"width":140,"blurWidth":0,"blurHeight":0};